import React from 'react';
import classNames from 'classnames';
import EmptyStateImage from 'assets/images/documents-ilustration.webp';
import ResolveImage from 'components/ResolveImage';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import UploadIcon from 'icons/Upload.icon';
import { Button } from 'ncoded-component-library';
import PlusIcon from 'icons/Plus.icon';
import ManageContactDrawer from '../../../../components/ManageContactDrawer';
import { SideDrawerRef } from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';
import useCallbackRef from 'hooks/useCallbackRef';
import BoltIcon from 'icons/Bolt.icon';
import LockclosedIcon from 'icons/Lockclosed.icon';
import ChecklistIcon from 'icons/Checklist.icon';

import './EmptyState.styles.scss';

const TILES = [
  {
    title: 'contactEmptyState_t1',
    description: 'contactEmptyState_d1',
    Icon: ChecklistIcon,
  },
  {
    title: 'contactEmptyState_t2',
    description: 'contactEmptyState_d2',
    Icon: BoltIcon,
  },
  {
    title: 'contactEmptyState_t3',
    description: 'contactEmptyState_d3',
    Icon: LockclosedIcon,
  },
];

type EmptyStateProps = {
  className?: string;
  updateContacts: () => void;
};

const EmptyState: React.FC<EmptyStateProps> = (props) => {
  const { className, updateContacts } = props;

  const [manageContactDrawer, manageContactDrawerRef] =
    useCallbackRef<SideDrawerRef>();

  const classes = classNames('empty-state-contacts', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <ResolveImage alt="Empty" src={EmptyStateImage} />

      <p>{t('emptyStateContactsTitle')}</p>

      <div className="tiles">
        {TILES.map(({ title, description, Icon }) => (
          <div key={title}>
            <Icon />
            <p>{t(title)}</p>
            <p className="description">{t(description)}</p>
          </div>
        ))}
      </div>

      <div className="actions">
        <Link to="add" className="ncoded-button ncoded-button--outline">
          <UploadIcon />
          {t('bulUploadContacts')}
        </Link>

        <Button
          variant="link"
          icon={PlusIcon}
          onClick={() => manageContactDrawer?.setOpen(true)}
        >
          {t('addOneAtATime')}
        </Button>
        <ManageContactDrawer
          ref={manageContactDrawerRef}
          onSuccess={updateContacts}
        />
      </div>
    </div>
  );
};

export default EmptyState;
